export default "__VITE_ASSET__KDkCoyHH__"